namespace RedBullMOBILE360.CVM {
    export class SegmentCriteriaColumns {
        static columnsKey = 'CVM.SegmentCriteria';
    }
}